<template>
  <v-layout fluid wrap fill-height class="idcs-pane-back main-layout">
    <v-flex xs12 v-show="vreport">
      <v-layout fluid wrap justify-center>
        <v-flex
          xs6
          sm4
          md3
          lg2
          v-for="r in $store.getters['report/reports']"
          :key="r.id"
          class="ma-2"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  :color="r.id>30?'orange':'teal'"
                  class="report-card-item"
                  :elevation="hover ? 16 : 2"
                  @click="openReport(r)"
                  v-on="on">
                  <v-card-actions
                    dark
                    class="white--text report-list-item"
                  >{{$store.getters['admin/msgById']({name_id:r.nameId}, $i18n.locale)}}</v-card-actions>
                  <v-img class="white--text align-center" :src="repimage(r)"></v-img>
                </v-card>
              </v-hover>
            </template>
            <span>{{$store.getters['admin/msgById']({name_id:r.nameId}, $i18n.locale)}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 v-show="vparams">
      <v-layout fluid class="align-center ma-2">
        <v-flex xs1>
          <v-btn v-if="totalItems" icon @click="d_print=true">
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </v-flex>
        <v-flex>{{$store.getters['admin/msgById']({name_id:selectedReport.nameId}, $i18n.locale)}}</v-flex>
        <v-flex xs4 class="text-right">
          <!--          <v-btn icon @click="reportExport('xls')">
            <v-icon>fa-file-excel</v-icon>
          </v-btn>
          <v-btn icon @click="reportExport('xml')">
            <v-icon>fa-file-download</v-icon>
          </v-btn>
          <v-btn icon @click="showReport">
            <v-icon>fa-tv</v-icon>
          </v-btn> !-->
          <div style="text-align: right">
            <v-btn icon @click="filterPane=!filterPane">
              <v-icon v-text="!filterPane?'mdi-filter-menu':'mdi-filter'"></v-icon>
            </v-btn>
            <v-btn icon @click="cancelReport" color="error">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-scroll-y-transition :appear="true">
        <v-layout
          v-show="filterPane"
          wrap
          class="mx-4 idcs-dialog-back filter-pane1 align-baseline"
        >
          <v-flex xs12>
            <v-subheader>{{$t('report.title1')}}</v-subheader>
          </v-flex>
          <v-flex v-if="inputs.sd" md4 lg3 xl2>
            <date-picker
              v-model="period"
              range
              confirm
              input-class="idcs-data-pick"
              :disabled-date="afternow"
              class="idcs-picker-wrap ml-4 mb-4"
              clearable
              :shortcuts="shortcuts"
              :lang="$i18n.locale"
            ></date-picker>
          </v-flex>
          <v-flex v-if="inputs.month" md4 lg3 xl2>
            <date-picker
              v-model="period[0]"
              type="month"
              format="MMM YYYY"
              :disabled-date="afternow"
              input-class="idcs-data-pick"
              class="idcs-picker-wrap ml-4 mb-4"
              clearable
              :lang="$i18n.locale"
            ></date-picker>
          </v-flex>
          <v-flex v-if="inputs.day" md4 lg3 xl2>
            <date-picker
              v-model="period[0]"
              type="date"
              :disabled-date="afternow"
              input-class="idcs-data-pick"
              class="idcs-picker-wrap ml-4 mb-4"
              clearable
              :lang="$i18n.locale"
            ></date-picker>
          </v-flex>
          <v-flex v-if="inputs.scomp" md4 lg3 xl2>
            <v-autocomplete
              prepend-inner-icon="fa-store"
              :label="$t('rec_types.SubCompanyRecord')"
              v-model="inp.scomp"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              clearable
              return-object
              :placeholder="$t('search.all')"
              :items="$store.getters['struct/subcompanies']"
              class="width-fit mx-4"
            ></v-autocomplete>
          </v-flex>
          <v-flex v-if="inputs.term" md4 lg3 xl2>
            <v-autocomplete
              prepend-inner-icon="fa-cash-register"
              :label="$t('rec_types.TerminalRecord')"
              v-model="inp.term"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              clearable
              return-object
              :placeholder="$t('search.all')"
              :items="$store.getters['struct/terminals']"
              class="width-fit mx-4"
            ></v-autocomplete>
          </v-flex>
          <v-flex v-if="inputs.termd" md4 lg3 xl2>
            <v-autocomplete
              prepend-inner-icon="fa-cog"
              :label="$t('rec_types.TerminalDetailRecord')"
              v-model="inp.termd"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              clearable
              return-object
              :placeholder="$t('search.all')"
              :items="$store.getters['struct/termdets']"
              class="width-fit mx-4"
            ></v-autocomplete>
          </v-flex>
          <v-flex v-if="inputs.oper" md4 lg3 xl2>
            <v-autocomplete
              :label="$t('rec_types.SystemDetailRecord')"
              prepend-inner-icon="fa-cog"
              v-model="inp.oper"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              clearable
              return-object
              :placeholder="$t('search.all')"
              :items="$store.getters['struct/opers']"
              class="width-fit mx-4"
            ></v-autocomplete>
          </v-flex>
          <v-flex v-if="inputs.cardDetType || inputs.cdtp" lg2>
            <v-select
              :label="$t('report.types')"
              prepend-inner-icon="fa-check-double"
              v-model="inp.cardDetType"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              clearable
              :placeholder="$t('report.types')"
              :items="cardValidTypes"
              class="width-fit mx-4"
            ></v-select>
          </v-flex>
          <v-flex v-if="inputs.sys" lg3>
            <v-autocomplete
              :label="$t('rec_types.SystemRecord')"
              prepend-inner-icon="fa-cogs"
              v-model="inp.sys"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              clearable
              return-object
              :placeholder="$t('search.all')"
              :items="$store.getters['struct/systems']"
              class="width-fit mx-4"
            ></v-autocomplete>
          </v-flex>
          <v-flex v-if="inputs.showZero" lg3>
            <v-select
              :label="$t('report.showZero')"
              prepend-inner-icon="fa-check-double"
              v-model="inp.showZero"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              clearable
              :placeholder="$t('showZeroTypes.exclude')"
              :items="showZeroTypes"
              class="width-fit mx-4"
            ></v-select>
            <!-- <v-checkbox :label="$t('report.showZero')" v-model="inp.showZero"></v-checkbox> -->
          </v-flex>
          <v-flex xs12 v-if="inputs.amt||inputs.grp">
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 v-if="inputs.amt||inputs.grp">
            <v-subheader>{{$t('report.title2')}}</v-subheader>
          </v-flex>
          <v-flex v-if="inputs.amt">
            <v-radio-group v-model="inp.amt" row class="ml-4">
              <v-radio :label="$t('report.amt.all')" value="1"></v-radio>
              <v-radio :label="$t('report.amt.amt1')" value="2"></v-radio>
              <v-radio :label="$t('report.amt.amt2')" value="3"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex v-if="inputs.grp">
            <v-radio-group v-model="inp.grp" row class="ml-4">
              <v-radio :label="$t('report.grp.terminal')" value="1"></v-radio>
              <v-radio :label="$t('report.grp.shop')" value="2"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 v-if="inputs.udata||inputs.edata">
            <v-divider></v-divider>
          </v-flex>
          <v-flex xs12 v-if="inputs.udata||inputs.edata">
            <v-subheader>{{$t('report.title3')}}</v-subheader>
            <v-row class="ml-4">
              <v-col cols="4">
                <v-checkbox v-if="inputs.udata" :label="$t('report.udata')" v-model="inp.udata"></v-checkbox>
              </v-col>
              <v-col cols="4">
                <v-checkbox v-if="inputs.edata" :label="$t('report.edata')" v-model="inp.edata"></v-checkbox>
              </v-col>
            </v-row>
          </v-flex>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-scroll-y-transition>
      <v-scroll-y-transition :appear="true">
        <v-layout
          v-show="filterPane"
          class="mt-0 mb-2 mx-4 idcs-main-back filter-pane2 align-baseline"
          wrap
        >
          <v-flex xs12 class="text-end ma-2">
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn-toggle v-model="texp" shaped mandatory class="d-inline" color="blue">
                  <v-btn
                    :disabled="loading"
                    value="display"
                    @click="getReport('display')"
                    v-on="on"
                    class="elevation-2"
                  >
                    <v-icon class="mr-2" color="orange">fa-tv</v-icon>
                    <span>{{$t('label.toDisplay')}}</span>
                  </v-btn>
                  <v-btn
                    :disabled="loading"
                    value="xml"
                    @click="getReport('xml')"
                    v-on="on"
                    class="elevation-2"
                  >
                    <v-icon class="mr-2" color="purple">fa-code</v-icon>
                    <span>{{$t('label.toXml')}}</span>
                  </v-btn>
                  <v-btn
                    :disabled="loading"
                    value="excel"
                    @click="getReport('excel')"
                    v-on="on"
                    class="elevation-2"
                  >
                    <v-icon class="mr-2" color="green darken-3">fa-file-excel</v-icon>
                    <span>{{$t('label.toExcel')}}</span>
                  </v-btn>
                  <v-btn
                    :disabled="loading"
                    value="csv"
                    @click="getReport('csv')"
                    v-on="on"
                    class="elevation-2"
                  >
                    <v-icon class="mr-2" color="pink">fa-file-csv</v-icon>
                    <span>{{$t('label.toCsv')}}</span>
                  </v-btn>
                </v-btn-toggle>
              </template>
              <span>{{$t("report.tt.actions")}}</span>
            </v-tooltip>

            <!--            <v-radio-group
              v-model="typeOfExport"
              :mandatory="true"
              dense
              :column="false"
              hint
              prepend-icon="mdi-pencil"
              class="download-radios justify-end mr-4"
            >
              <v-radio :label="$t('label.toDisplay')" value="display"></v-radio>
              <v-radio :label="$t('label.toXml')" value="xml"></v-radio>
              <v-radio :label="$t('label.toExcel')" value="excel"></v-radio>
              <template v-slot:append>
                <v-btn @click="getReport" rounded small>
                  <v-icon color="blue">mdi-download</v-icon>
                  <span style="color:blue;">{{$t('button.download')}}</span>
                </v-btn>
              </template>
            </v-radio-group>!-->
          </v-flex>
        </v-layout>
      </v-scroll-y-transition>
      <v-progress-linear indeterminate :active=loading></v-progress-linear>
      <v-divider></v-divider>
    </v-flex>
    <v-flex xs12 v-show="vtable" class="table-flex">
      <v-data-table
        :items="reportData"
        :headers="headers"
        :loading="loading"
        :items-per-page="10"
        item-key="pos"
        class="elevation-1 table-fluid idcs-pane-back"
        :no-data-text="$t('label.nodata')"
        :footer-props="{
        itemsPerPageOptions: [10, 50, 100], 
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-less-than',
        nextIcon: 'mdi-greater-than',
        itemsPerPageText: $t('label.rowPerPage')
      }"
      >
        <template v-slot:body.append="{ headers }">
          <tr>
            <template v-for="h in headers">
              <td
                v-if="h.filt=='currency'"
                :key="h.value"
                class="text-end idcs-main-back"
              >{{(selectedReport.summs?selectedReport.summs[h.value]:"") | currency}}</td>
              <td
                v-else
                :key="h.value"
                class="text-center idcs-main-back"
              >{{(selectedReport.summs?selectedReport.summs[h.value]:"")}}</td>
            </template>
          </tr>
        </template>
        <template v-slot:item="{ headers, item, index }">
          <tr :class="(index%2==0?'idcs-data-back':'idcs-data-back2')">
            <template v-for="h in headers">
              <td v-if="h.filt=='currency'" :key="h.value" :align="h.align">
                <span>{{item[h.value] | currency}}</span>
              </td>
              <td v-else-if="h.filt=='percent'" :key="h.value" :align="h.align">
                <span>{{item[h.value] | percent}}</span>
              </td>
              <td v-else-if="h.value=='pos'" :key="h.value" :align="h.align">
                <span>{{index+1}}</span>
              </td>
              <td
                v-else-if="h.value=='created' || h.value=='reversed'"
                :key="h.value"
                :align="h.align"
              >{{item[h.value] | dt-sec}}</td>
              <td
                v-else-if="h.value=='last_used' || h.value=='validcd' || h.value=='last_trans'"
                :key="h.value"
                :align="h.align"
              >{{item[h.value] | dt-time}}</td>
              <td
                v-else-if="h.value=='validc'"
                :key="h.value"
                :align="h.align"
              >{{item[h.value] | dt-only}}</td>
              <td v-else-if="h.label" :key="h.value" :align="h.align">{{$t(h.label+item[h.value])}}</td>
              <td v-else :key="h.value" :align="h.align">{{item[h.value]}}</td>
            </template>
          </tr>
        </template>
        <template v-slot:footer>
          <v-alert v-model="showMessage" dismissible type="error">{{alertMessage}}</v-alert>
        </template>
      </v-data-table>
    </v-flex>
    <PrintDialog v-model="d_print" :items="headers" :allin="true" @click:ok="printPage" />
  </v-layout>
</template>
<script>
import app from "@/app.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import PrintDialog from "@/components/PrintDialog";

export default {
  components: { DatePicker, PrintDialog },
  data() {
    return {
      d_print: false,
      //      print_all_det: false,
      inp: {},
      title: [],
      inputs: {},
      texp: "",
      filterPane: true,
      showMessage: false,
      alertMessage: "",
      selectedReport: {},
      oparams: 0,
      vparams: false,
      vreport: true,
      vtable: false,
      period: [new Date(), new Date()],
      cardValidTypes: [
        {
          text: this.$t("cardtypes.all"),
          value: 3,
        },
        {
          text: this.$t("cardtypes.valid"),
          value: 1,
        },
        {
          text: this.$t("cardtypes.invalid"),
          value: 2,
        },
      ],
      showZeroTypes: [
        {
          text: this.$t("showZeroTypes.exclude"),
          value: 1,
        },
        {
          text: this.$t("showZeroTypes.all"),
          value: 2,
        },
        {
          text: this.$t("showZeroTypes.only"),
          value: 3,
        },
      ],
      loading: false,
      reports: [],
      headers: [],
      reportData: [],
      shortcuts: [
        {
          text: this.$t("picker.today"),
          onClick() {
            return [new Date(), new Date()];
          },
        },
        {
          text: this.$t("picker.yesterday"),
          onClick() {
            const f = moment().subtract(1, "day").startOf("day").toDate();
            const e = moment().subtract(1, "day").endOf("day").toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.currentWeek"),
          onClick() {
            const f = moment().startOf("week").isoWeekday(1).toDate();
            const e = moment().toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.previousWeek"),
          onClick() {
            const f = moment()
              .subtract(1, "week")
              .startOf("week")
              .isoWeekday(1)
              .toDate();
            const e = moment().subtract(1, "week").endOf("week").toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.currentMonth"),
          onClick() {
            const f = moment().startOf("month").toDate();
            const e = moment().toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.previousMonth"),
          onClick() {
            const f = moment().subtract(1, "months").startOf("month").toDate();
            const e = moment().subtract(1, "months").endOf("month").toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.fromPreviousMonth"),
          onClick() {
            const f = moment().subtract(1, "months").startOf("month").toDate();
            const e = moment().toDate();
            return [f, e];
          },
        },
        {
          text: this.$t("picker.fromStartYear"),
          onClick() {
            const f = moment().startOf("year").toDate();
            const e = moment().toDate();
            return [f, e];
          },
        },
      ],
    };
  },
  computed: {
    // from() {
    //   return this.$moment(this.period[0]).format("ll");
    // },
    // to() {
    //   return this.$moment(this.period[1]).format("ll");
    // },
    totalItems() {
      return this.reportData.length;
    },
  },
  async mounted() {
    if (this.$store.getters["admin/errors"].length == 0) {
      await this.$store.dispatch("admin/LOAD_ERROR");
    }
    this.$store.dispatch("report/LOAD");
    if (!this.$store.getters["struct/isLoaded"]) {
      this.$store.dispatch("struct/LOAD_STRUCT");
    }
  },
  methods: {
    repimage(r) {
      try {
        if (r.sorted.substring(0, 1) == "@") {
          return (
            "./img/" +
            r.sorted.substring(1) +
            (r.sorted.indexOf(".") == -1 ? ".svg" : "")
          );
        }
      } catch (e) {
        return "./img/1.svg";
      }
      return "./img/1.svg";
    },
    afternow(date) {
      return this.$moment(date).isAfter();
    },
    printPage() {
      let opts = {
        title: this.$store.getters["admin/msgById"](
          { name_id: this.selectedReport.nameId },
          this.$i18n.locale
        ),
        filter: {},
        sd: this.$options.filters["dt-only"](this.period[0]),
        ed: this.$options.filters["dt-only"](this.period[1]),
      };
      for (let k in this.inp) {
        if (this.inp[k] != "" && typeof this.inp[k] != "undefined") {
          if (k == "udata" || k == "edata") {
            continue;
          } else if (k == "amt") {
            if (this.inp[k] == "2") {
              opts.filter.amt = this.$t("report.amt.amt1");
            } else if (this.inp[k] == "3") {
              opts.filter.amt = this.$t("report.amt.amt2");
            }
          } else {
            opts.filter[this.alias(k)] = this.inp[k].text;
          }
        }
      }
      let footers = { totals: this.selectedReport.summs };
      let head = [];
      this.headers.forEach((e) => {
        if (e.prn) {
          head.push(e);
        }
      });
      if (head.length == 0) return;
      app.generatePrintPage({ items: this.reportData }, head, opts, footers);
    },
    openReport(r) {
      this.inp = {};
      this.inputs = {};
      try {
        r.inputPars.split(",").forEach((e) => {
          try {
            this.inp[e.trim()] = "";
            this.inputs[e.trim()] = true;
            if (e == "amt") {
              this.inp[e] = "1";
            }
            if (e == "grp") {
              this.inp[e] = "1";
            }
            if (e == "month") {
              this.inp[e] = true;
            }
            if (e == "edata" && this.$store.getters.iface != 1) {
              this.inp[e] = true;
            }
          } catch (e) {
            console.log(e);
          }
        });
      } catch (e) {
        console.log("error split", r.inputPars);
      }
      this.selectedReport = r;
      this.oparams = 0;
      this.vparams = true;
      this.vreport = false;
    },
    cancelReport() {
      this.selectedReport = {};
      this.vparams = false;
      this.vreport = true;
      this.vtable = false;
      this.reportData = [];
      this.showMessage = false;
      this.filterPane = true;
      this.print_all_det = false;
    },
    getReport(t) {
      this.selectedReport.summs = 0;
      if (t == "display") {
        this.showReport();
      } else if (t == "excel") {
        this.reportExport("xls");
      } else if (t == "xml") {
        this.reportExport("xml");
      } else if (t == "csv") {
        this.reportExport("csv");
      }
    },
    reportExport(f) {
      if (!f) f = "xml";
      let fields = this.selectedReport.fields.split(",");
      let hdrs = [];
      fields.forEach((element) => {
        let el = element.split("=");
        let eln = el[0].trim();
        let n = this.$t("field." + eln.toLowerCase());
        if (n instanceof Array)
          n = this.$t(
            "field." + eln.toLowerCase() + "." + this.$store.getters.iface
          );
        let hdr = {
          name: n,
          field: eln,
        };
        hdrs.push(hdr);
      });

      let params = this.buildParams();
      params.repFormat = f;
      params.headers = hdrs;
      this.loading = true;
      app.reportExport(params, params).finally(() => {
        this.loading = false;
      });
    },
    alias(v) {
      if (v == "termd") return "tdId";
      if (v == "oper") return "sdId";
      if (v == "sys") return "sysId";
      if (v == "cardDetType") return "cdtp";
      return v;
    },
    buildParams() {
      if (this.period[0] == null) this.period[0] = new Date();
      if (this.period[1] == null) this.period[1] = new Date();
      if (this.inp.month) {
        this.period[0] = this.$moment(this.period[0]).startOf("month").toDate();
        this.period[1] = this.$moment(this.period[0]).endOf("month").toDate();
      }
      let params = {
        pk: this.selectedReport.id,
        sd: this.$moment(this.period[0]).format("YYYYMMDD"),
        ed: this.$moment(this.period[1]).format("YYYYMMDD"),
      };
      console.log(this.inp);
      for (let k in this.inp) {
        if (this.inp[k] != "" && typeof this.inp[k] != "undefined") {
          if (
            k == "amt" ||
            k == "grp" ||
            k == "udata" ||
            k == "edata" ||
            k == "showZero" ||
            k == "cardDetType"
          ) {
            params[this.alias(k)] = this.inp[k];
          } else {
            params[this.alias(k)] = this.inp[k].value;
          }
        }
      }
      return params;
    },
    addDefaultHeaders() {
      let fields = this.selectedReport.fields.split(",");
      this.headers = [];
      fields.forEach((element) => {
        let el = element.split("=");
        let eln = el[0].trim();
        let n = this.$t("field." + eln);
        if (n instanceof Array)
          n = this.$t(
            "field." + eln.toLowerCase() + "." + this.$store.getters.iface
          );
        let hdr = {
          text: n,
          value: eln,
          sortable: true,
          align: "center",
          prn: true,
        };
        if (eln == "created" || eln == "reversed") {
          hdr.filt = "dt-time";
        } else if (eln == "validc" || eln == "valid") {
          hdr.filt = "dt-only";
        } else if (
          eln == "validcd" ||
          eln == "last_used" ||
          eln == "last_trans"
        ) {
          hdr.filt = "dt-time";
        } else if (eln == "status") {
          hdr.label = "status.";
        } else if (
          eln.toLowerCase().indexOf("d_debet") != -1 ||
          eln.toLowerCase().indexOf("debet") != -1 ||
          eln.toLowerCase().indexOf("debit") != -1 ||
          eln.toLowerCase().indexOf("amount") != -1 ||
          eln == "next_month" ||
          eln == "m1" ||
          eln == "m2" ||
          eln == "m3" ||
          eln == "m4" ||
          eln == "m5" ||
          eln == "m6" ||
          eln == "m7" ||
          eln == "m8" ||
          eln == "m9" ||
          eln == "m10" ||
          eln == "m11" ||
          eln == "m12"
        ) {
          hdr.align = "end";
          hdr.width = "150";
          hdr.filt = "currency";
        }
        this.headers.push(hdr);
      });
    },
    calculateTotals() {
      if (this.selectedReport.totals.trim() != "") {
        let tot = this.selectedReport.totals.split(",");
        this.selectedReport.summs = {};
        this.reportData.forEach((v) => {
          tot.forEach((t) => {
            try {
              if (!this.selectedReport.summs[t]) {
                this.selectedReport.summs[t] = 0;
              }
              if (v[t]) this.selectedReport.summs[t] += v[t];
            } catch (e) {
              console.error(e);
            }
          });
        });
      }
    },
    addExtendedHeaders(c) {
      try {
        if (c && c.udata) {
          c.udata.split(",").forEach((e) => {
            this.headers.push({
              text: this.$t("field." + e.toLowerCase()),
              value: e,
              sortable: true,
              prn: false,
              align: "center",
            });
          });
        }
      } catch (e) {
        console.error(e.message);
      }
      try {
        if (c && c.edata) {
          c.edata.split(",").forEach((e) => {
            let el = {
              text: this.$t("field." + e.trim().toLowerCase()),
              value: e.trim(),
              prn: false,
              sortable: true,
              align: "center",
            };
            if (e == "operation" || e == "rec_nr") {
              el.text = this.$t("field." + e.trim().toLowerCase());
            } else if (e.indexOf("debit") != -1) {
              el.filt = "currency";
              el.align = "right";
            } else if (
              e == "discount_0" ||
              e == "current_discount_0" ||
              e == "discount_n"
            ) {
              el.filt = "percent";
            } else if (e == "amount_discount_0" || e == "amount_discount_n") {
              el.filt = "currency";
              el.align = "right";
            }
            this.headers.push(el);
          });
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    updateTitle() {
      this.title = [];
      this.title.push(this.$moment(this.period[0]).format("ll"));
      this.title.push(this.$moment(this.period[1]).format("ll"));
      for (let k in this.inp) {
        if (this.inp[k] != "" && typeof this.inp[k] != "undefined") {
          if (k == "amt" || k == "udata" || k == "edata") {
            this.title.push(this.inp[k]);
          } else {
            this.title.push(this.inp[k].text);
          }
        }
      }
    },
    showReport() {
      this.vtable = true;
      this.reportData = [];
      this.loading = true;
      this.showMessage = false;
      this.addDefaultHeaders();
      app
        .getReport(this.buildParams())
        .then((response) => {
          this.reportData = [];
          this.reportData = response.items.slice();
          this.addExtendedHeaders(response.config);
          this.calculateTotals();
          this.updateTitle();
          if (this.texp == "display" && this.reportData.length)
            this.filterPane = false;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          if (error.status == 303) {
            console.log(error);
            this.showMessage = true;
            this.alertMessage = this.$t("error." + error.statusText);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.download-radios {
  width: auto;
}
.main-layout {
  border-radius: 4px;
}
.report-card-item :hover {
  cursor: pointer;
}
.report-list-item {
  height: 84px;
  -webkit-box-pack: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.table-fluid {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.table-flex {
  height: inherit;
}
.filter-pane1 {
  border-radius: 25px 25px 0 0;
}
.filter-pane2 {
  border-radius: 0 0 25px 25px;
  margin-top: -20px;
}
.width-fit {
  width: fit-content;
}
</style>